import React, { useEffect, useState } from 'react';
import moment from 'moment';

import { Link } from 'react-router-dom';
import Header from '../../components/Header';
import withStateDispatch from '../../redux/withStateDispatch';
import { callFBFunction } from '../../utils/firebase';
import SearchIcon from '../../assets/image/icons/search-icon.svg';
import { filterByValue } from '../../helpers/app';
import NoInformation from '../../components/NoInformation';
import { getRewardTitle } from '../../helpers/specialGiftConditions';

const RedemptionHistory = ({ setLoader }) => {
  const [search, setSearch] = useState('');
  const [history, setHistory] = useState([]);
  const [sorting, setSorting] = useState(false);

  useEffect(() => {
    setLoader(true);
    callFBFunction('getRedemptionHistory').then(({ data: response }) => {
      const res = response?.data.sort(
        (a, b) => moment(b.redeemed_at._seconds * 1000) - moment(a.redeemed_at._seconds * 1000)
      );

      if (sorting) {
        const filteredData = res.filter((item) => item.type === 'referrer');
        setHistory(filterByValue(filteredData, search));
      } else {
        const filteredData = res.filter((item) => item.type === 'referral');
        setHistory(filterByValue(filteredData, search));
      }
      setLoader(false);
    });
  }, [search, sorting]);

  return (
    <div className="max-w-screen-md mx-auto">
      <Header title="Redemption History" subtitle="Past Reward Claims" showBack={false} />

      <div className="flex flex-col gap-4 p-5">
        <div className="flex-1 flex flex-row gap-2 items-center text-[12px] text-[#CDCDCD] border-b-[1px] border-[#EAEAED] pb-2.5">
          <img className="w-[17px] aspect-square" src={SearchIcon} alt="back" />
          <input
            className="flex-1 bg-transparent border-0 focus:ring-0 text-black p-0 font-inter"
            name="search"
            placeholder="Search"
            type="text"
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        <div className="hs-tooltip flex items-center justify-between gap-x-3">
          <div>
            <label
              htmlFor="hs-tooltip-example"
              className="text-sm text-black font-semibold font-inter">
              Sorted your history by:
            </label>
            <p className="text-sm text-[#5046E4] font-inter">{sorting ? 'Referrer' : 'Referral'}</p>
          </div>
          <label
            htmlFor="hs-tooltip-example"
            className="hs-tooltip-toggle relative inline-block w-11 h-6 cursor-pointer"
            data-hs-tooltip-content={sorting ? 'Sort by Referrer' : 'Sort by Referral'}>
            <input
              type="checkbox"
              id="hs-tooltip-example"
              className="peer sr-only"
              value={sorting}
              onClick={() => setSorting(!sorting)}
            />
            <span className="absolute inset-0 bg-gray-200 rounded-full transition-colors duration-200 ease-in-out peer-checked:bg-[#5046E4] dark:peer-checked:bg-[#5046E4] peer-disabled:opacity-50 peer-disabled:pointer-events-none" />
            <span className="absolute top-1/2 start-0.5 -translate-y-1/2 size-5 bg-white rounded-full shadow-xs transition-transform duration-200 ease-in-out peer-checked:translate-x-full" />
          </label>
        </div>
      </div>

      <div className="flex flex-col gap-2 overflow-y-scroll mx-5 pb-10">
        {history.length > 0 ? (
          history?.map((item) => {
            const rewardTitle = getRewardTitle(item);
            return (
              <div key={item.id} className="flex flex-row p-2 border rounded-md transition-all">
                <div className="flex-1">
                  {item?.type === 'referrer' && (
                    <>
                      <h1 className="text-md font-bold font-inter text-primary">{rewardTitle}</h1>
                      <p className="text-sm font-inter">
                        {item?.user_info?.name?.first} {item?.user_info?.name?.last}
                      </p>
                      <p className="text-sm font-light font-inter text-quaternary">
                        {item?.user_info?.email?.primary} ({item?.user_info?.phone?.mobile})
                      </p>
                    </>
                  )}
                  {item?.type === 'referral' && (
                    <>
                      <h1 className="text-md font-extrabold font-inter text-primary">
                        {rewardTitle}
                      </h1>
                      <p className="text-sm font-inter">
                        {item?.name?.first} {item?.name?.last}
                      </p>
                      <p className="text-sm font-light font-inter text-quaternary">
                        {item?.email} ({item?.phone})
                      </p>
                    </>
                  )}
                </div>
                <div className="flex-3">
                  <p className="text-end text-xs text-quaternary font-inter font-extralight">
                    {item?.reward?.redeemed_at &&
                      moment(item.reward.redeemed_at._seconds * 1000).format('DD-MM-YYYY')}
                  </p>
                  <p className="text-end text-xs text-green-500 font-inter font-bold">
                    {item?.reward?.redeemed_at && 'Claimed'}
                  </p>
                </div>
              </div>
            );
          })
        ) : (
          <NoInformation
            title="No Redemption History Available"
            content={
              <>
                We apologize, but it seems you're currently not having any redemptions history. To
                redeem any cupon, please visit the{' '}
                <Link className="text-[#5046E4]" to="/scan-qr">
                  Scan QR
                </Link>{' '}
                feature.
              </>
            }
          />
        )}
      </div>
    </div>
  );
};

export default withStateDispatch(RedemptionHistory);
